import React, { useEffect, useState } from "react";

import IconTextItem from "@appsinti/ui-core/IconTextItem";

import WeatherIcon from "../resources/img/weather-icon.svg";

import useI18n from "@appsinti/i18n/useI18n";
import CurrentTemperature from "@appsinti/common-utils/interfaces/weather/CurrentTemperature";
import { useTemperature } from "@appsinti/temperature-provider";
import initCurrentTemperature from "./data";


const Preview: React.FC<{ appId: number }> = ({ appId }) => {
  const { translate } = useI18n();
  const { temperatureObject } = useTemperature();
  const [temperature, setTemperature] =
    useState<CurrentTemperature | null>(null);

  useEffect(() => {
    initCurrentTemperature(appId, setTemperature);
  }, []);

  return (
    <IconTextItem
      icon={WeatherIcon}
      isImage={true}
      body={
        temperature ? (
          <>
            {translate("Weather")} (
            {temperatureObject(temperature.temperature)})
          </>
        ) : (
          <>{translate("Weather")}</>
        )
      }
    />
  );
};

export default Preview;
